export const DRAWER_WIDTH = 288;

export const LAYOUT_STYLES = {
  drawer: {
    background: 'linear-gradient(180deg, #1e3a8a 0%, #1e40af 50%, #3b82f6 100%)',
  },
  appBar: {
    backgroundColor: 'white',
    color: '#2c3e50',
    borderBottom: '1px solid rgb(200,200,200)',
    boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
  },
  toolbar: {
    backgroundColor: 'white',
    color: '#2c3e50',
    borderBottom: '1px solid rgba(255,255,255,0.1)',
  },
} as const;